function apply(moduleConfig) {
	if (moduleConfig.floors) {
		moduleConfig.floors.additionalSchemaFields = _getAdditionalSchemaFieldGetters();
	}
}

// Defaults schema fields are gptSlot, adUnitCode, mediaType, size
function _getAdditionalSchemaFieldGetters() {
	return {
		'bidder': _getFromBidResponse('bidder'),
		'width': _getFromBidResponse('width'),
		'height': _getFromBidResponse('height'),
		'currency': _getFromBidResponse('currency'),
		'creativeId': _getFromBidResponse('creativeId')
	};
}

function _getFromBidResponse(field) {
	return (bidResponse) => bidResponse[field] ? `${bidResponse[field]}` : '*';
}

module.exports = {
	apply
};
